import React,{useEffect} from 'react' 
import HomeSlider from'../Component/HomeSlider'  
import Message from'../Component/Message'
import News from'../Component/News'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX' 
import Highlights from'../Component/Highlights'
import { Link } from 'react-router-dom'
import Popup from'../Component/Popup'
import Activity from'../Component/Activity'
import OnlineRegistration from'../Component/OnlineRegistration'
import Campuscare from'../Component/Campuscare' 
import Header from'../Component/Header'
const Home = () => {
  useEffect(() => {
    document.title = 'Home -  St. Josephs School Quadian Punjab';  
}, []); 
  return (
    <>   
    <Popup/>
    <Campuscare/>
    <OnlineRegistration/>
    <Header/>
       <Highlights/>
      
       <HomeSlider/> 
       <div className="homeabout">
         <div className="container-fluid padded-sec">
            <div className="row">  
               <div className="col-xl-8 col-lg-12">
               <div class="clearfix">
               <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/schoolimg.jpg" class="img-fluid col-sm-12 col-md-5 float-md-start mb-3 schoolimg" alt=""/>
               <div class="maintitle">
                     <p>About us</p>
                     <h1>ST.JOSEPH CONVENT SCHOOL,   <span>QADIAN</span></h1>
                 </div> <p className="homeaboutpara">  St. Joseph's Convent School, Dalla Morh, Qadian is established, owned and administered by the Diocese of Jalandhar, registered charitable Society, as one among its several prestigious schools all over Punjab and certain parts of Himachal Pradesh. This is an unaided minority educational institution with all its privileges guaranteed by the Supreme Constitution of India, under the Articles 29, 30 (1). His Excellency, the Catholic Bishop of Jalandhar, appointed by the Holy Father (pope) in Rome is the Patron of this school and the President of the Society. </p>
                 <button className='button'><Link to="/AboutUs"> READ MORE  <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </Link></button> 
               </div>      
            </div>
            <div className="col-xl-4 col-lg-12">
                 <News/>
            </div>
        </div>
       </div>
     </div>
       <div className="messagebgsec">
        <div className="container-fluid padded-sec">
           <div className="row">  
                <div className="col-lg-12">
                  <div class="maintitle">
                      <p>message section</p>
                      <h1>from the  <span>desk of</span></h1>
                  </div>
                </div>
             <div className="col-lg-12">
                  <Message/>
             </div>
         </div>
        </div>
      </div>
       <div className="topper_bg">
       <div className="container">
         <div className="row">  
                <div className="col-lg-12">
                <div class="maintitle">
                    <p>Toppers section</p>
                    <h1>Our School <span>Achievers</span></h1>
                </div>
                </div>
                <div className="col-lg-12">
                <div className='topper-block'>
                   <h6>TOPPER X</h6>
                <TopperX />
                </div>
                <button className='button'><Link to="/Toppers">VIEW ALL  <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/> </Link></button> 
              </div>  
            { /*  <div className="col-lg-6">
                <div className='topper-block'>
                <h6>TOPPER XII</h6>
                <TopperXII />
                </div>
                 <button className='button'><Link to="/ToppersXII">VIEW ALL  <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/></Link></button> 
           </div>  */}
         </div>
       </div>
      </div> 
      <div className="activitysec">
        <div className="container-fluid padded-sec">
            <div className="row">  
              <div className="col-lg-12">
                 <Activity/>
              </div>
        </div>
        </div> 
      </div>
   
    </>
  )
}

export default Home
